import { render, staticRenderFns } from "./WhsL_List.vue?vue&type=template&id=56183935"
import script from "./WhsL_List.vue?vue&type=script&lang=js"
export * from "./WhsL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports